import React from "react";

export default function AdminSettingsWorkspacePage() {
  return <div>AdminSettingsWorkspacePage</div>;
}
